import React from 'react';
import {motion} from 'framer-motion';
import {experience} from '../data/content';

function Experience() {
  return (
    <section className="pad" id="experience">
      <div className="wrap experience-layout">
        <div className="section-head experience-intro">
          <span className="eyebrow">Experience</span>
          <h2 className="h-section">My journey so far</h2>
          <p>Six years of building,shipping and learning across agencies,products and freelance clients.</p>
        </div>
        <motion.div className="timeline" initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.6}}>
          {experience.map((e)=> (
            <div className="tl-item" key={e.role + e.company}>
              <div className="tl-head">
                <span className="tl-role">{e.role}</span>
                <span className="tl-when">{e.when}</span>
              </div>
              <div className="tl-company">{e.company}</div>
              <div className="tl-desc">{e.desc}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default Experience;
